import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">T</div>
              <span>HZD-ERP</span>
            </div>
            <p className="footer-description">
              Empowering TikTok Shop sellers with powerful management tools.
            </p>
          </div>

          <div className="footer-links">
            <h3>Product</h3>
            <a href="#/features">Features</a>
            <a href="#/contact">Pricing</a>
            <a href="#/contact">API Documentation</a>
          </div>

          <div className="footer-links">
            <h3>Company</h3>
            <a href="#/about">About Us</a>
            <a href="#/contact">Contact</a>
          </div>

          <div className="footer-links">
            <h3>Legal</h3>
            <a href="#/privacy">Privacy Policy</a>
            <a href="#/terms">Terms of Service</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 HZD-ERP All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
